import { CanalNotificationDto, Correspondant, MessageNotificationSearchCriteria } from "@resources/resources";
import { ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Component, EventEmitter, Output } from "@angular/core";
import { MomentService } from "@digicerba/common";
import { UserStore } from "@digicerba/common";
import { MessageNotificationSearchCriteriaWithHiglightDto } from "@common/models/message-notification-search-criteria-highlight";
import { Subject } from "rxjs";

@Component({
  selector: 'filtres-consultation-alertes',
  templateUrl: './filtres-consultation-alertes.component.html',
  host: {'class': 'filter'}
})
export class FiltresConsultationAlertesComponent {

  filterForm: FormGroup;
  canaux: Array<CanalNotificationDto>;
  correspondants: Array<Correspondant>;

  checkbox: HTMLElement;

  isLu: Boolean;
  isNotLu: Boolean;

  subject = new Subject<MessageNotificationSearchCriteriaWithHiglightDto>();

  @Output() onFiltering = new EventEmitter<MessageNotificationSearchCriteriaWithHiglightDto>();

  constructor(private momentService: MomentService, fb: FormBuilder,
              private activatedRoute: ActivatedRoute, userStore: UserStore) {

    this.isLu = null;
    this.isNotLu = null;

    this.filterForm = fb.group({
      notification: null,
      isLu: null,
      canauxSelected: null,
      dateDebutSelected: null,
      dateFinSelected: null,
      correspondantsSelected: []
    });

    this.correspondants = userStore.getUser().correspondants;
    this.canaux = this.activatedRoute.snapshot.data['canauxActifsUtilisateur'];

    this.filterForm.valueChanges.debounceTime(750).subscribe(() => {
      this.submit();
    })
  }

  ngOnInit(){
    this.subject.asObservable().debounceTime(1000).subscribe (  (searchCriteria : MessageNotificationSearchCriteriaWithHiglightDto) => {
      this.onFiltering.emit(searchCriteria);
    });
  }

  ngAfterViewInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      let canal: string = params['canal'];
      if(canal != null){
        let canalDto : CanalNotificationDto = this.canaux.find(element => element.code === canal)
        if(canalDto != null){
          (document.getElementById(canalDto.id+``).children[1] as HTMLElement).click();
          (document.getElementById(`NonLu`).children[1] as HTMLElement).click();
        }
      }
    });
  }

  submit() {
    let searchCriteria: MessageNotificationSearchCriteriaWithHiglightDto = {
      messageNotificationSearchCriteria: {
        canalIds: this.filterForm.value.canauxSelected,
        datePublicationMin: this.momentService.formatToLocalDate(this.filterForm.value.dateDebutSelected),
        datePublicationMax: this.momentService.formatToLocalDate(this.filterForm.value.dateFinSelected),
        read: this.filterForm.value.isLu,
        messageCorrespondants: this.filterForm.value.correspondantsSelected,
        notification: this.filterForm.value.notification
      },
      termsToHighlight: this.getTermsToHighlight()
    }

    this.subject.next(searchCriteria);
  }

  public choseCanal(selected: boolean, canal: CanalNotificationDto): void {
    if (this.filterForm.value.canauxSelected == null) {
      this.filterForm.value.canauxSelected = new Array<string>();
    }
    if (selected) {
      this.filterForm.value.canauxSelected.push(canal.id);
    } else {
      var index = this.filterForm.value.canauxSelected.indexOf(canal.id, 0);
      this.filterForm.value.canauxSelected.splice(index, 1);
    }
    this.submit();
  }

  public choseCorrespondant(selected: boolean, correspondant: Correspondant): void {
    if (this.filterForm.value.correspondantsSelected == null) {
      this.filterForm.value.correspondantsSelected = new Array<string>();
    }
    if (selected) {
      this.filterForm.value.correspondantsSelected.push(correspondant.code);
    } else {
      var index = this.filterForm.value.correspondantsSelected.indexOf(correspondant.code, 0);
      this.filterForm.value.correspondantsSelected.splice(index, 1);
    }
    this.submit();
  }

  public choseLu(isLu: boolean): void {
    this.isLu = isLu;
    if ((this.isLu == null && this.isNotLu == null) || (!this.isLu && !this.isNotLu) || (this.isLu && this.isNotLu)) {
      this.filterForm.value.isLu = null;
    } else {
      this.filterForm.value.isLu = isLu;
    }
    this.submit();
  }

  public choseNonLu(isNotLu: boolean): void {
    this.isNotLu = isNotLu;
    if ((this.isLu == null && this.isNotLu == null) || (!this.isLu && !this.isNotLu) || (this.isLu && this.isNotLu)) {
      this.filterForm.value.isLu = null;
    } else {
      this.filterForm.value.isLu = !isNotLu;
    }
    this.submit();
  }

  public onDateDebutChange(date: { day: number, month: number, year: number }): void {
    if (this.isDateValid(date)) {
      let dateFormated: Date = this.formatToDate(date, true);
      this.filterForm.value.dateDebutSelected = dateFormated;
    } else {
      this.filterForm.value.dateDebutSelected = null;
    }
    this.submit();
  }

  public onDateFinChange(date: { day: number, month: number, year: number }): void {
    if (this.isDateValid(date)) {
      let dateFormated: Date = this.formatToDate(date, false);
      this.filterForm.value.dateFinSelected = dateFormated;
    } else {
      this.filterForm.value.dateFinSelected = null;
    }
    this.submit();
  }

  private formatToDate(date: { day: number, month: number, year: number }, isDateDebut: boolean): Date {
    if (isDateDebut) {
      return new Date(date.year, date.month - 1, 1);
    }
    let lastDayOfMonth: number = new Date(date.year, date.month, 0).getDate();
    return new Date(date.year, date.month - 1, lastDayOfMonth);
  }

  private isDateValid(date: { day: number, month: number, year: number }): boolean {
    return date.month != null && date.year != null;
  }

  private getTermsToHighlight(): string {
    let termsToHighlight;

    const formValues = this.filterForm.value;
    if (formValues.notification != null) {
      termsToHighlight = formValues.notification.toString();
    } else {
      termsToHighlight = '';
    }
    return termsToHighlight;
  }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/consultation/filtres/filtres-consultation-alertes.component.ts